export type HubSpotContactProperty = {
  name: string;
  label: string;
};

export type HubSpotContactPropertiesResponse = {
  results: HubSpotContactProperty[];
};

export type HubSpotItemsState<Item> = {
  items: Item[];
  loading: boolean;
  error: { message: string } | null;
};

export type HubSpotContactPropertiesState =
  HubSpotItemsState<HubSpotContactProperty>;

export type State = {
  contactProperties: HubSpotContactPropertiesState;
};

export const defaultState: State = {
  contactProperties: {
    items: [],
    loading: false,
    error: null,
  },
};
